











import { defineComponent, ref } from '@vue/composition-api';
/** 商城全屏协议模块 */
import FqMallFullScreenProtocol from '@/widgets/installment-contract/ContractPop.vue';
import { ContractListItem, CreditMallContractSceneEnum } from '@/api/rights/shop-mall/types';
import { queryMultiContractList } from '@/api/rights/shop-mall';
import { RouterV2Enum } from '@/router/router-names';
import router from '@/router';
import type { CreditMallApplyResponse } from '@/api/rights/shop-mall/types';

export default defineComponent({
  name: 'InstallmentMallPreApply',
  components: {
    FqMallFullScreenProtocol,
  },
  props: {
    productId: {
      type: String,
      required: true,
    },
    from: {
      type: String,
      required: true,
    },
  },
  setup(props, context) {
    const contractList = ref<ContractListItem[]>([]);
    const productIds = ref<string[]>([]);
    const fqMallEntranceData = ref<{ applyAmount?: string }>({});

    const fetchContractList = async () => {
      const productIdList = decodeURIComponent(props.productId).split(',');
      productIds.value = productIdList;
      const result = await queryMultiContractList({
        productIdList,
        scene: CreditMallContractSceneEnum.CREDIT,
      });
      contractList.value = result?.contractList || [];
      return result?.contractList;
    };

    const applySuccessCallback = (response: CreditMallApplyResponse) => {
      if (response?.creditTaskId) {
        router.replace({
          path: RouterV2Enum.unitWaitingPage,
          query: {
            creditTaskId: response.creditTaskId,
            from: props.from,
            isCheckDcContracts: 'false',
          },
        });
      }
    };

    // 初始化时获取协议列表
    fetchContractList();

    return {
      contractList,
      productIds,
      fqMallEntranceData,
      applySuccessCallback,
    };
  },
});
